import { render, staticRenderFns } from "./PurchaseTicket.vue?vue&type=template&id=79b8e6b4&scoped=true&style=background-color%3A%20%23EAEAEA"
import script from "./PurchaseTicket.vue?vue&type=script&lang=js"
export * from "./PurchaseTicket.vue?vue&type=script&lang=js"
import style0 from "./PurchaseTicket.vue?vue&type=style&index=0&id=79b8e6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b8e6b4",
  null
  
)

export default component.exports